import { useCallback, useEffect, useState } from "react";
import { Search, Wallet } from "lucide-react";
import api, { inr } from "../../lib/api";
import { AdminWalletAdjust } from "../../components/AdminWalletAdjust";

export default function AdminWallets() {
  const [wallets, setWallets] = useState(null);
  const [adjusting, setAdjusting] = useState(null);
  const [q, setQ] = useState("");

  const load = useCallback(() => api.get("/admin/wallets").then(({ data }) => setWallets(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const filtered = (wallets || []).filter((w) => !q || (w.name || "").toLowerCase().includes(q.toLowerCase()) || (w.email || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-wallets-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">Wallets</h1>
          <p className="text-sm text-slate-500">Customer balances — add or deduct money with full audit trail.</p>
        </div>
        <div className="relative w-72">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input data-testid="wallets-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search customer…"
            className="w-full rounded-xl border border-slate-200 bg-white py-2.5 pl-9 pr-4 text-sm focus:border-shipany-blue focus:outline-none" />
        </div>
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="admin-wallets-table">
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="bg-shipany-navy text-left text-xs uppercase tracking-wider text-white">
              <th className="px-5 py-3.5">Customer</th><th className="px-4 py-3.5">Balance</th><th className="px-4 py-3.5">Currency</th><th className="px-4 py-3.5"></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((w) => (
              <tr key={w.wallet_id} className="border-t border-slate-100 hover:bg-slate-50/60" data-testid={`wallet-row-${w.email}`}>
                <td className="px-5 py-3.5"><p className="font-semibold text-shipany-navy">{w.name}</p><p className="text-xs text-slate-400">{w.email}</p></td>
                <td className="mono px-4 py-3.5 text-lg font-bold text-shipany-blue">{inr(w.balance)}</td>
                <td className="px-4 py-3.5 text-slate-500">{w.currency}</td>
                <td className="px-4 py-3.5 text-right">
                  <button onClick={() => setAdjusting(w)} data-testid={`adjust-${w.email}`}
                    className="flex items-center gap-1.5 rounded-lg bg-shipany-blue px-4 py-2 text-xs font-bold text-white hover:bg-[#0648B3]">
                    <Wallet className="h-3.5 w-3.5" /> Add Balance
                  </button>
                </td>
              </tr>
            ))}
            {wallets && !filtered.length && <tr><td colSpan={4} className="px-6 py-12 text-center text-slate-400">No wallets match your search.</td></tr>}
          </tbody>
        </table>
      </div>

      {adjusting && <AdminWalletAdjust target={{ user_id: adjusting.user_id, email: adjusting.email, name: adjusting.name, balance: adjusting.balance }} onClose={() => setAdjusting(null)} onDone={load} />}
    </div>
  );
}
